module.exports = __webpack_public_path__ + "img/suport active.35c32eaf.svg";